// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CrmDomeinVerificatieGetDomeinenPerAdviseurResponse } from '../model/crmDomeinVerificatieGetDomeinenPerAdviseurResponse.ts';

import type { DomeinVerificatieCheckStatusParams } from '../model/domeinVerificatieCheckStatusParams.ts';

import type { DomeinVerificatieGetDomeinenParams } from '../model/domeinVerificatieGetDomeinenParams.ts';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails.ts';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
 * @summary Haalt de huidige status van de domein verificatie op.
 */
export const domeinVerificatieCheckStatus = (
  params?: MaybeRefOrGetter<DomeinVerificatieCheckStatusParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<void>(
    { url: `/api/v1/domein-verificatie/status`, method: 'GET', params, signal },
    options,
  );
};

export const getDomeinVerificatieCheckStatusQueryKey = (
  params?: MaybeRefOrGetter<DomeinVerificatieCheckStatusParams>,
) => {
  return ['api', 'v1', 'domein-verificatie', 'status', ...(params ? [params] : [])] as const;
};

export const getDomeinVerificatieCheckStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof domeinVerificatieCheckStatus>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<DomeinVerificatieCheckStatusParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domeinVerificatieCheckStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getDomeinVerificatieCheckStatusQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof domeinVerificatieCheckStatus>>> = ({
    signal,
  }) => domeinVerificatieCheckStatus(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof domeinVerificatieCheckStatus>>,
    TError,
    TData
  >;
};

export type DomeinVerificatieCheckStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof domeinVerificatieCheckStatus>>
>;
export type DomeinVerificatieCheckStatusQueryError = ErrorType<void>;

/**
 * @summary Haalt de huidige status van de domein verificatie op.
 */

export function useDomeinVerificatieCheckStatus<
  TData = Awaited<ReturnType<typeof domeinVerificatieCheckStatus>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<DomeinVerificatieCheckStatusParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domeinVerificatieCheckStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDomeinVerificatieCheckStatusQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
 * @summary Haalt de domeinen op per adviseur.
 */
export const domeinVerificatieGetDomeinen = (
  params?: MaybeRefOrGetter<DomeinVerificatieGetDomeinenParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CrmDomeinVerificatieGetDomeinenPerAdviseurResponse[]>(
    { url: `/api/v1/domein-verificatie/domeinen`, method: 'GET', params, signal },
    options,
  );
};

export const getDomeinVerificatieGetDomeinenQueryKey = (
  params?: MaybeRefOrGetter<DomeinVerificatieGetDomeinenParams>,
) => {
  return ['api', 'v1', 'domein-verificatie', 'domeinen', ...(params ? [params] : [])] as const;
};

export const getDomeinVerificatieGetDomeinenQueryOptions = <
  TData = Awaited<ReturnType<typeof domeinVerificatieGetDomeinen>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<DomeinVerificatieGetDomeinenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domeinVerificatieGetDomeinen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getDomeinVerificatieGetDomeinenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof domeinVerificatieGetDomeinen>>> = ({
    signal,
  }) => domeinVerificatieGetDomeinen(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof domeinVerificatieGetDomeinen>>,
    TError,
    TData
  >;
};

export type DomeinVerificatieGetDomeinenQueryResult = NonNullable<
  Awaited<ReturnType<typeof domeinVerificatieGetDomeinen>>
>;
export type DomeinVerificatieGetDomeinenQueryError = ErrorType<void>;

/**
 * @summary Haalt de domeinen op per adviseur.
 */

export function useDomeinVerificatieGetDomeinen<
  TData = Awaited<ReturnType<typeof domeinVerificatieGetDomeinen>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<DomeinVerificatieGetDomeinenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domeinVerificatieGetDomeinen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDomeinVerificatieGetDomeinenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
 * @summary Verstuur instructies om DKIM- en SPF-records in te regelen.
 */
export const domeinVerificatieSendDnsRecordInstructions = (
  domeinVerificatieSendDnsRecordInstructionsBody?: MaybeRefOrGetter<string>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  domeinVerificatieSendDnsRecordInstructionsBody = toValue(
    domeinVerificatieSendDnsRecordInstructionsBody,
  );

  return customInstance<void>(
    {
      url: `/api/v1/domein-verificatie/send-dns-record-instructions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: domeinVerificatieSendDnsRecordInstructionsBody,
      signal,
    },
    options,
  );
};

export const getDomeinVerificatieSendDnsRecordInstructionsMutationOptions = <
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domeinVerificatieSendDnsRecordInstructions>>,
    TError,
    DomeinVerificatieSendDnsRecordInstructionsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domeinVerificatieSendDnsRecordInstructions>>,
  TError,
  DomeinVerificatieSendDnsRecordInstructionsMutationVariables,
  TContext
> => {
  const mutationKey = ['domeinVerificatieSendDnsRecordInstructions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domeinVerificatieSendDnsRecordInstructions>>,
    DomeinVerificatieSendDnsRecordInstructionsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return domeinVerificatieSendDnsRecordInstructions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomeinVerificatieSendDnsRecordInstructionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof domeinVerificatieSendDnsRecordInstructions>>
>;
export type DomeinVerificatieSendDnsRecordInstructionsMutationBody = string | undefined;
export type DomeinVerificatieSendDnsRecordInstructionsMutationError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;
export type DomeinVerificatieSendDnsRecordInstructionsMutationVariables = { data?: string };

/**
 * @summary Verstuur instructies om DKIM- en SPF-records in te regelen.
 */
export const useDomeinVerificatieSendDnsRecordInstructions = <
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof domeinVerificatieSendDnsRecordInstructions>>,
      TError,
      DomeinVerificatieSendDnsRecordInstructionsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof domeinVerificatieSendDnsRecordInstructions>>,
  TError,
  DomeinVerificatieSendDnsRecordInstructionsMutationVariables,
  TContext
> => {
  return useMutation(
    getDomeinVerificatieSendDnsRecordInstructionsMutationOptions(options),
    queryClient,
  );
};
